/**
 * Generated runtime TestId mirror for frontend/src/pages/analytics/EffectiveAccessBySystem.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const EffectiveAccessBySystemTestIds = {
  colActions: "col-actions",
  colEnvironment: "col-environment",
  colSystem: "col-system",
  colType: "col-type",
  effectiveAccessBySystemPage: "effective-access-by-system-page",
  btnViewAccess: (system_id: string) => `btn-view-access-${system_id}`,
  btnViewAccessPrefix: () => "btn-view-access-" as TestIdPrefix,
  linkSystem: (system_id: string) => `link-system-${system_id}`,
  linkSystemPrefix: () => "link-system-" as TestIdPrefix
} as const;
